// extracted by mini-css-extract-plugin
export default {"goldenAge":"golden-age_goldenAge__zfzCD"};